import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-navigation" }
const _hoisted_2 = { key: 0 }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigation',
  props: {
  isAuthenticated: {
    type: Boolean,
    default: false,
  },

  isLoginPossible: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (!__props.isAuthenticated && __props.isLoginPossible)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            class: "inverted",
            to: { path: '/login' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('nav.login')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (__props.isAuthenticated)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              class: "inverted",
              to: { path: '/' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.dashboard')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              class: "inverted",
              to: { path: '/profile' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.profile')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              class: "inverted",
              to: { path: '/results' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.results')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, {
              class: "inverted",
              to: { path: '/logout' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.logout')), 1)
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})